/* Compteurs des Voix, lus sur voicesofcacao.com. Rien n'est écrit ici.
   La ligne reste cachée si le fichier n'est pas là dans les 4 secondes. */
(function () {
  "use strict";
  var late = false;
  window.setTimeout(function () { late = true; }, 4000);

  function line(tpl, lieu) {
    var map = { L: lieu.ecouter, W: lieu.regarder, R: lieu.lire };
    return String(tpl || "").split(" · ").filter(function (part) {
      var mark = part.match(/§([LWR])/);
      return mark && map[mark[1]] > 0;
    }).map(function (part) {
      return part.replace(/§([LWR])/g, function (_, k) { return String(map[k]); });
    }).join(" · ");
  }

  function apply(data) {
    if (!data || late) return;
    var total = data.total || {};
    document.querySelectorAll("[data-voix-totaux]").forEach(function (el) {
      var n = total[el.getAttribute("data-voix-totaux")];
      if (typeof n !== "number") return;
      var slot = el.querySelector("[data-voix-n]");
      if (slot) slot.textContent = String(n);
      el.hidden = false;
    });
    document.querySelectorAll(".mv2[data-porte]").forEach(function (slot) {
      var key = slot.getAttribute("data-voix-key");
      var lieu = data.lieux && data.lieux[key];
      var node = slot.querySelector(".mv2__counts");
      if (!node || !lieu) return;
      var text = line(node.getAttribute("data-tpl"), lieu);
      if (!text) return;
      node.textContent = text;
      node.hidden = false;
    });
  }

  document.addEventListener("voix-compteurs", function (event) {
    apply((event && event.detail) || window.VOIX_COMPTEURS);
  });
  if (window.VOIX_COMPTEURS) apply(window.VOIX_COMPTEURS);
})();
